export const constructStrRep = (obj) => {
  if (obj.str_representation) return obj.str_representation;
  return "Indexuppräkning";
};

export const overviewUrl = () => ``;

export const detailUrl = ({ id }) =>
  `/configcenter/indexations/settings/detail/${id}`;
